export default function () {

  $(document).on('ready', function(){

    $('.product__quick-view a').on('click', function(e) {
      e.preventDefault();
      var modalLocation = $(this).attr('data-reveal-id');
      $('#'+modalLocation).foundation('open');
    });

    $('.close-reveal-modal').on('click', function(e) {
      e.preventDefault();
      var modalLocation = $(this).parent().attr('id');
      $('#'+modalLocation).foundation('close');
    });

    $('.product-search a').on('click', function(e) {
      e.preventDefault();
      var modalLocation = $(this).attr('data-reveal-id');
      $('#'+modalLocation).foundation('open');
      $('#'+modalLocation).addClass('open');
    });

    $('.reveal .close-btn').on('click', function(e) {
      e.preventDefault();
      var modalLocation = $(this).parent().attr('id');
      $('#'+modalLocation).removeClass('open');
    })

	});
}



// WEBPACK FOOTER //
// ./scripts/components/SetupModals.js